import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Subscription } from '../../../../../node_modules/rxjs';
import { BoxQuotaData } from '../../../model/box.quote.data';

@Component({
    selector: 'cu-download-link-cell-pnl-renderer',
    template: `<span  [ngClass]="{'green-fa': PnlValue>0, 'red-fa': PnlValue<0}">{{pnlString}}</span>`
  })

  
  export class OrderPnlCellRenderer {
      params:any;
      constructor( ) { 

      }
      
      
      agInit(params:any): void { 
          this.params = params;
         

          this.pnlString = ( this.params.data.PnLUSD!=null )?String(this.params.data.PnLUSD):""; 
         
          if( this.pnlString!=null)
          {
            let direction:number = this.pnlString.indexOf("-");

            if(direction>=0)
            {
               this.PnlValue = -1;
            }
            else{
              this.PnlValue = 1;
            }

            if(this.pnlString=="$0.00")
            {
              this.PnlValue=0;
            }
          }
          else
          {
            this.pnlString = "";
          }
     }
    


     refresh(params: any): void {
      this.params = params;

      // console.log("refreshPNL");
      // console.log(this.params.data);
      

      this.pnlString = ( this.params.data.PnLUSD!=null )?String(this.params.data.PnLUSD):""; 
         
      if( this.pnlString!=null)
        {
          let direction:number = this.pnlString.indexOf("-");

          if(direction>=0)
          {
            this.PnlValue = -1;
          }
          else{
            this.PnlValue = 1;
          }

          if(this.pnlString=="$0.00")
          {
            this.PnlValue=0;
          }
        }
        else
        {
          this.pnlString = "";
        }
       }

     private _PnlValue:number = 0;

     set PnlValue(v:number)
     {
       this._PnlValue = v;
     }
      get PnlValue():number
      {
        return this._PnlValue;
      }

      private _pnlString:string = "";

      set pnlString(v:string)
      {
        this._pnlString = v;
      }

      get pnlString():string
      {
        return this._pnlString;
      }
  }
  
  export type CellAction = (params:any) => void;